import * as Styled from './_styled/hamburger-menu-container.styled'
import {useDimensions} from '../../../../contexts/dimensions/use-dimensions'
import {useRef, type JSX} from 'react'
import {useOnClickOutside} from '../../../../hooks/useOnClickOutside'
import {HamburgerButton} from './hamburger-button'
import {HamburgerMenu} from './hamburger-menu'
import {useToggle} from '../../../../contexts/toggle/use-toggle'
import {useGlobalVesselFilterContext} from '@/components/global-vessel-filter/global-vessel-filter-context'

export function HamburgerMenuContainer(): JSX.Element {
    const {width} = useDimensions()

    const {value: isNavbarOpen, setValue: setToggle} = useToggle()

    const clickOutside = useRef<HTMLDivElement>(null)

    const {isOpen: isFilterPopoverOpen} = useGlobalVesselFilterContext()

    useOnClickOutside(clickOutside, () => {
        if (isFilterPopoverOpen) {
            return
        }
        setToggle(false)
    })
    return (
        <Styled.LeftContainerStyle width={width} ref={clickOutside}>
            <HamburgerButton />
            {isNavbarOpen && <HamburgerMenu />}
        </Styled.LeftContainerStyle>
    )
}
